export const alignments = [
    "Lawful Good",
    "Neutral Good",
    "Chaotic Good",
    "Lawful Neutral",
    "True Neutral",
    "Chaotic Neutral",
    "Lawful Evil",
    "Neutral Evil",
    "Chaotic Evil",
]

export const rarities = {
    common: 37,
    rare: 30,
    epic: 20,
    legendary:10,
    unique:3
}

export const spellRarities = {
    0: 20,
    1: 30,
    2: 30,
    3: 25,
    4: 25,
    5: 20,
    6: 15,
    7: 10,
    8: 10,
    9: 5,
    10:5,
}
export const featRarities = {
    martial:25,
    magic:22,
    utility:25,
    style:10,
    teamwork:5,
    metamagic:8,
    key:0,
    prereq:0,
}
export const statRarities = {
    abilityScore:36,
    misc:28,
    skills:36,
}

export const expPerLevel = [
    650, 3300, 6000, 10000, 15000, 23000, 34000, 50000, 71000, 105000, 145000, 210000, 295000, 425000, 600000, 850000, 1200000, 1700000, 2400000
]

export const diceSteps = [
    "1","1d2","1d3","1d4","1d6","1d8,2d4","1d10","2d6,1d12","2d8","3d6,2d10","3d8","4d6","4d8","6d6","6d8","8d6","8d8,5d12","12d6","12d8","16d6","16d8","24d6","24d8"
]

export const maneuverTypeRarities = {
    Strike:26,
    Boost:25,
    Stance:18,
    Counter:25,
    Finisher:6,
}
export const sizeMods = {
    "fine":8,
    "diminutive":4,
    "tiny":2,
    "small":1,
    "medium":0,
    "large":-1,
    "huge":-2,
    "gargantuan":-4,
    "colossal":-8,
}